<template>
  <svg
    width="162"
    height="162"
    viewBox="0 0 162 162"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M133.5 139.5C92.2349 166.536 69.25 165.904 28.5 139.5C28.5 139.5 43.5 107 81 107.5C118.5 108 133.5 139.5 133.5 139.5Z"
      fill="var(--accentColor)"
    />
    <path
      d="M81 107.25C99.1218 107.25 113.812 92.5593 113.812 74.4375C113.812 56.3157 99.1218 41.625 81 41.625C62.8782 41.625 48.1875 56.3157 48.1875 74.4375C48.1875 92.5593 62.8782 107.25 81 107.25Z"
      stroke="var(--contrastColor)"
      stroke-width="3"
      stroke-miterlimit="10"
    />
    <path
      d="M28.3359 139.57C33.2735 129.845 40.8076 121.677 50.1033 115.971C59.3989 110.265 70.0929 107.245 81 107.245C91.9071 107.245 102.601 110.265 111.897 115.971C121.192 121.677 128.727 129.845 133.664 139.57"
      stroke="var(--contrastColor)"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M120.375 21.9375H159.75"
      stroke="var(--contrastColor)"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M140.062 2.25V41.625"
      stroke="var(--contrastColor)"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M158.766 68.6134C159.429 72.7088 159.758 76.8514 159.75 81.0002C159.75 96.5754 155.131 111.801 146.478 124.751C137.825 137.702 125.526 147.795 111.136 153.756C96.7467 159.716 80.9127 161.276 65.6367 158.237C50.3607 155.198 36.3288 147.698 25.3154 136.685C14.302 125.671 6.80178 111.64 3.76319 96.3635C0.724608 81.0875 2.28412 65.2535 8.24452 50.8638C14.2049 36.4741 24.2985 24.1751 37.2489 15.5219C50.1993 6.86875 65.4248 2.25015 81 2.25015C85.1488 2.242 89.2914 2.57121 93.3868 3.23452"
      stroke="var(--contrastColor)"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  components: {},
  props: [],
};
</script>
<style scoped></style>
